import { type ComponentProps } from "react";
import { FormLabel as MuiFormLabel } from "@mui/material";

import type { TranslationKeyAndOptions } from "@thalamos/vision-common";

import { Translation } from "../../Translation/Translation.js";

export const FormLabel = ({
  translationKey,
  translationOptions,
  ...props
}: TranslationKeyAndOptions & ComponentProps<typeof MuiFormLabel>) => {
  return (
    <MuiFormLabel {...props} sx={{ fontWeight: "bold" }}>
      <Translation
        translationKey={translationKey}
        translationOptions={translationOptions}
      />
    </MuiFormLabel>
  );
};
